import { createCacheSingleton } from '@gitbook/util-suspense-cache';

export async function excalidraw() {
    return import('./excalidraw.lazy');
}

export const excalidrawSuspense = createCacheSingleton(() => excalidraw());

export type { ExcalidrawElement } from '@excalidraw/excalidraw/element/types';
export type {
    BinaryFiles as ExcalidrawBinaryFiles,
    ExcalidrawImperativeAPI,
} from '@excalidraw/excalidraw/types';
